import { Customer } from "@jugl-web/rest-api";
import { useTranslations } from "@jugl-web/utils";

import { useCustomerData } from "@jugl-web/domain-resources/customers/hooks/useCustomerData";
import { UserCardItem } from "@jugl-web/domain-resources/users/components/UserCardItem";
import { useCustomersContext } from "@jugl-web/domain-resources/customers/providers/useCustomersContext";

export const CustomerCard = ({
  customer,
  isSelected,
  searchQuery,
  isAdmin,
  onSelect,
}: {
  customer: Customer;
  isAdmin?: boolean;
  isSelected?: boolean;
  searchQuery?: string;
  onSelect: (customerId: string) => void;
}) => {
  const { t } = useTranslations();

  const redundantFields = ["first_name", "last_name"];
  const { attributes, companyName, customerName } = useCustomerData(customer);
  const { queryFilters } = useCustomersContext();
  const visibleAttributes = attributes
    .filter((attr) => (isAdmin ? true : attr?.visibility))
    .filter((attr) => attr && redundantFields.includes(attr.nameId) === false)
    .map((item) => ({
      ...item,
      preventSearchQueryHighlight: !queryFilters.includes(item.id),
    }));

  return (
    <UserCardItem
      variant="customer"
      name={customerName}
      subtitle={
        companyName ||
        t({ id: "common.no-company", defaultMessage: "No Company" })
      }
      isSelected={isSelected}
      id={customer.id}
      searchQuery={searchQuery}
      onSelect={onSelect}
      avatarUrl={customer.logo || undefined}
      attributes={visibleAttributes.filter(
        (e): e is Exclude<typeof e, null> => e !== null
      )}
      selectVariant="checkbox"
    />
  );
};
